export default __webpack_public_path__ + "static/media/leader_notes.4da9c980.pdf";